/**
 * @file ToolsMenu.style.js
 * Exports ToolsMenu component styles.
 */

export default theme => ({
  button: {
    display: 'block',
    marginTop: theme.spacing.unit * 2,
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center'
  },
  link: {
    paddingTop: theme.spacing.unit * 1.6
  },
  wrapper: {
    marginBottom: theme.spacing.unit * 2
  }
});



// WEBPACK FOOTER //
// ./src/components/ToolsMenu/ToolsMenu.style.js